var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "manage-import" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.isCopy ? "复制小程序" : "管理引用",
            visible: _vm.dialogVisible,
            width: "600px",
            "destroy-on-close": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.close,
          },
        },
        [
          _c(
            "el-form",
            { attrs: { form: _vm.form, "label-width": "100px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "选择小程序：" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        clearable: "",
                        multiple: !Boolean(_vm.isCopy),
                        "value-key": "id",
                        placeholder: "请选择",
                      },
                      model: {
                        value: _vm.form.list,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "list", $$v)
                        },
                        expression: "form.list",
                      },
                    },
                    _vm._l(_vm.companyappList, function (opt) {
                      return _c("el-option", {
                        key: opt.id,
                        attrs: { label: opt.appName, value: opt.bindValue },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.close } }, [_vm._v("取 消")]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { loading: _vm.loading, type: "primary" },
                  on: { click: _vm.submit },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }